module.exports = __webpack_public_path__ + "static/media/doghouse.a6aedeec.png";